import { useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { lastVisitedPageAtom } from "./lastVisitedPageAtom";
import { clientConfigAtom } from "atoms/clientConfig";
import { serverSessionAtom } from "atoms/serverSession";
import { AppRoute } from "app/AppFlow";
import { replaceSessionInAppRoute } from "utils/routeHelper";

/**
 * Redirects users to the last page they visited in case they leave
 * and return to the app.
 */
export const useLastVisitedPage = () => {
  const [lastVisitedPage, setLastVisitedPage] = useAtom(lastVisitedPageAtom);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const serverSession = useAtomValue(serverSessionAtom);
  const hasPayeeEnabledInSession = !!serverSession?.enablePayeeJourney;
  const {
    enablePayeeJourney,
    speedyPayment,
  } = useAtomValue(clientConfigAtom);

  /**
   * On initial render, redirect to the last page the user visited
   * if exists.
   */
  useEffect(() => {
    if (lastVisitedPage && !(enablePayeeJourney && hasPayeeEnabledInSession)) {
      navigate(lastVisitedPage + search, {
        replace: true,
      });
    } else if (enablePayeeJourney && hasPayeeEnabledInSession) {
      navigate(
        replaceSessionInAppRoute(
          speedyPayment?.showRepairablePage ? AppRoute.EstimateRepariablePayee : AppRoute.SpeedyPayment,
          serverSession?.id
        )
      );
    }
    // Disabling eslint rule as we want this hook only to fire on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * On each page change, cache the last page the user visited.
   */
  useEffect(() => {
    setLastVisitedPage(pathname);
  }, [pathname, setLastVisitedPage]);
};
